import RadioButtonList, { RadioButtonListProps } from './RadioButtonList';

export type { RadioButtonListProps };
export default RadioButtonList;
